import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import './css/mobilemenu.css';

const StyledBurger = styled.div`
  width: 2rem;
  height: 1.3rem;
  position: relative;
  top: 1.7rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  flex-flow: column nowrap;
  z-index: 99999;

  div {
    width: 1.8rem;
    height: 0.15rem;
    background-color: ${({ open }) => (open ? '#fff' : 'var(--mainColor)')};
    border-radius: 3px;
    transform-origin: 1px;
    transition: all 0.5s linear;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? 'rotate(39deg)' : 'rotate(0)')};
    }

   :nth-child(2) {
     opacity: ${({ open }) => (open ? '0' : '1')};
     transform: ${({ open }) => (open ? 'translateX(-20px)' : 'translateX(0)')};
    }

    &:nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-39deg)' : 'rotate(0)')};
    }
  }
`;

const MenuNav = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  background-color: var(--mainColor);
  transition: transform 0.8s ease-in-out;
  z-index: 9999;
`;


const BurgerMenu = () => {
  const [open, setOpen] = useState(false);
  const [offsetX,setOffsetX] = useState(0);
  const [offsetY,setOffsetY] = useState(0);

  const cursor = document.querySelector('.cursor');

  const handleMosueEffect = ()=> {
    cursor.style.left = offsetX+'px';
    cursor.style.top = offsetY+'px';
  }


  useEffect(()=>{
    const updateMouseEvent = (e) =>{
      setOffsetX(e.clientX);
      setOffsetY(e.clientY);
    }

    window.addEventListener("mousemove",updateMouseEvent);

    return ()=> window.removeEventListener("mousemove",updateMouseEvent);
  })

  // console.log(open);
  return (
    <div className='mobile-menu-screen' onMouseMove={handleMosueEffect}>
      <StyledBurger open={open} onClick={() => setOpen(!open)}>
        <div />
        <div />
        <div />
      </StyledBurger>

      <MenuNav open={open}>
        <div className='top-nav-mobile'>
            <ul>
              <li onClick={() => setOpen(!open)} ><NavLink to='/'>home</NavLink></li>
              <li onClick={() => setOpen(!open)}><NavLink to='/about'>about</NavLink></li>
              <li onClick={() => setOpen(!open)}><NavLink to='/gallery'>gallery</NavLink></li>
              <li onClick={() => setOpen(!open)}><NavLink to='/projects'>projects</NavLink></li>
              <li onClick={() => setOpen(!open)}><NavLink to='/contact'>contact</NavLink></li>
              <div className='cursor'></div>
            </ul>
        </div>
      </MenuNav>
      
    </div>
  );
};

export default BurgerMenu;
